import { StatusType } from './logger';
export function reportRawError(error, sender) {
    var messageContext = {
        date: error.startClocks.timeStamp,
        error: {
            kind: error.type,
            origin: error.source,
            stack: error.stack,
        },
        origin: error.source,
    };
    sender.sendToHttp(error.message, messageContext, StatusType.error);
}
//# sourceMappingURL=reportRawError.js.map